import React, { useEffect, useState } from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import Check from "@material-ui/icons/Check";
import Checkbox from "@material-ui/core/Checkbox";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/modules/scrollbar/scrollbar.min.css";
import { Scrollbar, Mousewheel, FreeMode, Grid, Navigation, Pagination } from "swiper";

const useStyles = makeStyles(styles);

const RefinementList = ({
  items,
  refine,
  setOosOnly,
  oosOnly,
  showAllItems,
}) => {
  const classes = useStyles();
  const [myOosOnly, setMyOosOnly] = useState(oosOnly);

  return (
    <div>
      <Swiper
        freeMode
        spaceBetween={0}
        mousewheel={true}
        grid={{
          rows: 2,
          fill: "row"
        }}
        slidesPerView={2}
        freeModeMinimumVelocity={0}
        freeModeMomentumBounceRatio={2}
        freeModeMomentumRatio={1}
        freeModeMomentumVelocityRatio={1}
        scrollbar={{
          hide: false,
        }}
        pagination={{ clickable: true }}
        style={{ width: '100%', height: '100%' }}
        navigation
        modules={[Scrollbar, Mousewheel, FreeMode, Grid, Navigation, Pagination]}
      >
        {items
          .sort((a, b) => {
            if (a.count > b.count) {
              return -1;
            }
            if (b.count > a.count) {
              return 1;
            }
            return 0;
          })
          .map((item) => (
            <SwiperSlide
              className={item.isRefined ? "cell active" : "cell"}
              key={item.label}
              onClick={(event) => {
                event.preventDefault();
                refine(item.value);
              }}
            >
              <a href="#">
                {item.label} ({item.count})
              </a>
            </SwiperSlide>
          ))}
      </Swiper>
      {!showAllItems ? (
        <div>
          <Checkbox
            checked={myOosOnly}
            onClick={(e) => {
              setMyOosOnly(!myOosOnly);
              setOosOnly(!myOosOnly);
            }}
            checkedIcon={<Check className={classes.checkedIcon} />}
            icon={<Check className={classes.uncheckedIcon} />}
            classes={{
              checked: classes.checked,
              root: classes.checkRoot,
            }}
          />{" "}
          Only show out of stock items
        </div>
      ) : null}
    </div>
  );
};

const CustomRefinementList = connectRefinementList(RefinementList);

export default CustomRefinementList;
